import { OnboardHREmpDetail } from "./OnboardHREmpDetail";
import { OnboardEducationDetails } from "./OnboardEducationDetails";
import { OnboardPreviousEmploymentDetails } from "./OnboardPreviousEmploymentDetails";
import { OnboardProfessionalReferenceDetails } from "./OnboardProfessionalReferenceDetails";
import { OnboardVisaInformation } from "./OnboardVisaInformation";
import { OnboardEmergencyContactDetails } from "./OnboardEmergencyContactDetails";
import { OnboardVrifications } from "./OnboardVrifications";
import { Designation } from "./Designation";
import { FileToUpload } from "./filetoupload";
export class OnboardingHRDetail {
  EmpId: number;
  EmpEmailId: string;
  FirstName: string;
  LastName: string;
  Slug: string;
  Status: number;
  DOJ: Date;
  NamePerRecords: string;
  LocationID: number;
  LocationName: string;
  DesignationId: number;
  EmpType: string;
  mobileNumber: string;
  CadreId: number;
  DepartmentId: number;
  IsDeleted: number;
  ProfileSource: string;
  ProfileSourceCategoryOne: string;
  ProfileSourceCategoryTwo: string;
  RecruiterId: number;
  RecruiterDesignationId: number;
  JoiningBonus: string;
  CurrentURL: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  employeeDetails: OnboardHREmpDetail = new OnboardHREmpDetail();
  educationDetails: OnboardEducationDetails[];
  previousEmploymentDetails: OnboardPreviousEmploymentDetails[];
  professionalrefDetails: OnboardProfessionalReferenceDetails[];
  visaDetails: OnboardVisaInformation[];
  Designation: any;
  emerContactDetails: OnboardEmergencyContactDetails[];
  onboardVrifications: OnboardVrifications[];
  HiringType: any;
  CadreName: string;
  DesignationName: string;
  EmpStatus: string;
  EmpCode: number;
  Type: string;
  GroupId: string;
  FixedCTC: number;
  employeeBonusDetails: OnboardEmployeeBonusDetails[];
  RelocationEligibility: string;
  OfferLetterFile: FileToUpload;
  OfferLetterDocumentName: string;
  OfferLetterDocumentPath: string;
  Employee_Status: string;
  ResumeLastUpdated: string;
  EETypeId: number;
  TeamId: number;
  employeeBonusDetailsList: any[];
  offerLetterDetails: any[];
  orgEmployeeBonusDetailsList: any[];
}

export class HRempHiringDetails {
  EmpCode: number;
  ProfileSource: string;
  ProfileSourceCategoryOne: string;
  ProfileSourceCategoryTwo: string;
  RecruiterId: number;
  RecruiterDesignationId: number;
  JoiningBonus: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  HiringType: string;
  FixedCTC: number;
  employeeBonusDetails: EmployeeBonusDetails[];
  RelocationEligibility: string;
  OfferLetterFile: FileToUpload;
  OfferLetterDocumentName: string;
  OfferLetterDocumentPath: string;
  employeeSalaryAdvances: EmployeeSalaryAdvances[];
  employeeCarLeases: EmployeeCarLeases[];
  employeeBonusDetailsList: any[];
  orgEmployeeBonusDetailsList: any[];
  offerLetterDetails: any[];
}

export class EmployeeBonusDetails {
  Id: number;
  EmpCode: number;
  BonusId: number;
  Name: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  Amount: number;
}

export class OnboardEmployeeBonusDetails {
  Id: number;
  EmpId: number;
  BonusId: number;
  Name: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  Amount: number;
}

export class EmployeeBonus {
  Id: number;
  Name: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  IsCTC: boolean;
}

export class EmployeeSalaryAdvances {
  Id: number;
  EmpCode: number;
  Amount: number;
  PayOutDate: Date;
  FromMonth: string;
  ToMonth: string;
  ApproverCode: number;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  ApproverInvalid: boolean;
  employeeSalaryAdvanceDetails: EmployeeSalaryAdvanceDetails[];
}

export class EmployeeSalaryAdvanceDetails {
  Id: number;
  EmpCode: number;
  SalaryAdvanceId: number;
  Month: string;
  Amount: number;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
}

export class EmployeeCarLeases {
  Id: number;
  EmpCode: number;
  Amount: number;
  PayOutDate: Date;
  FromMonth: string;
  ToMonth: string;
  ApproverCode: number;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  employeeCarLeaseDetails: EmployeeCarLeaseDetails[];
}

export class EmployeeCarLeaseDetails {
  Id: number;
  EmpCode: number;
  SalaryAdvanceId: number;
  Month: string;
  Amount: number;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
}
